import { render, staticRenderFns } from "./AldProgramParticipationDetails.vue?vue&type=template&id=29d4a12c&"
import script from "./AldProgramParticipationDetails.vue?vue&type=script&lang=ts&"
export * from "./AldProgramParticipationDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/organs/liver/_locales/AldProgram.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Forgans%2Fliver%2FAldProgramParticipationDetails.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports